module.exports = __webpack_public_path__ + "99d6d2c983847eea625ebf7dec10229b.jpg";